import { Star } from "lucide-react";
import { TESTIMONIALS } from "../content";
import { Reveal } from "./Reveal";

const Testimonials = () => (
  <section className="py-20 lg:py-32" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-mono-alt text-xs uppercase tracking-[0.35em] text-[#D4AF37]">Whispers from early readers</p>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#F8FAFC] leading-tight">
            Quiet book. Loud aftertaste.
          </h2>
        </div>
        <div className="flex items-center gap-3" data-testid="rating-summary">
          <div className="flex gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
            ))}
          </div>
          <span className="text-sm text-[#94A3B8]">4.9 / 5 from early readers</span>
        </div>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="h-full rounded-lg border border-[#D4AF37]/15 bg-[#0A404E] p-8 flex flex-col justify-between transition-all duration-500 hover:border-[#D4AF37]/40 hover:-translate-y-1"
            >
              <blockquote className="font-serif-alt italic text-xl text-[#F8FAFC] leading-relaxed">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6">
                <p className="text-sm font-semibold text-[#FCD34D]">{t.name}</p>
                <p className="text-xs text-[#94A3B8] mt-0.5">{t.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
